import React from 'react';
import PropTypes from 'prop-types';

const PREV_BUTTON_CLASSNAME =
  'react-multiple-carousel__arrow react-multiple-carousel__arrow--left';
const NEXT_BUTTON_CLASSNAME =
  'react-multiple-carousel__arrow react-multiple-carousel__arrow--right';

const CarouselCustomButtonGroup = (
  //   prevButton,
  //   nextButton,
  { next, previous, prevButton, nextButton, ...rest },
) => {
  const {
    carouselState: { currentSlide, totalItems },
  } = rest;

  const handlePrevious = e => {
    e.stopPropagation();
    previous();
  };

  const handleNext = e => {
    e.stopPropagation();
    next();
  };

  let customPrevButton;
  if (prevButton) {
    customPrevButton = React.cloneElement(prevButton, {
      onClick: handlePrevious,
      className: PREV_BUTTON_CLASSNAME,
    });
  }

  let customNextButton;
  if (nextButton) {
    customNextButton = React.cloneElement(nextButton, {
      onClick: handleNext,
      className: NEXT_BUTTON_CLASSNAME,
    });
  }

  return (
    <div className="mr-products-container-carousel__arrows">
      {currentSlide !== 0 && (
        <>
          {customPrevButton ? (
            <>{customPrevButton}</>
          ) : (
            <button
              type="button"
              className={PREV_BUTTON_CLASSNAME}
              onClick={handlePrevious}
            />
          )}
        </>
      )}
      {currentSlide !== totalItems - 1 && (
        <>
          {customNextButton ? (
            <>{customNextButton}</>
          ) : (
            <button
              type="button"
              className={NEXT_BUTTON_CLASSNAME}
              onClick={handleNext}
            />
          )}
        </>
      )}
    </div>
  );
};

CarouselCustomButtonGroup.propTypes = {
  next: PropTypes.func,
  previous: PropTypes.func,
  nextButton: PropTypes.node,
  prevButton: PropTypes.node,
};

export default CarouselCustomButtonGroup;
